<template>
  <BaseTableWrapper v-if="$route.name === 'EXSBPriceUserDataList'">
    <template #top-buttons>
      <div class="float-right mb-1">
        <router-link tag="button" :to="{ name: 'EXSBPriceUserDataCreate' }" class="btn btn-sm btn-primary">{{ $t('buttons.create') }}</router-link>
      </div>
    </template>
    <template #filtering></template>
    <template #body>
      <div v-if="isLoading">
        <Loader></Loader>
      </div>
      <div v-else-if="!isLoading && items.length < 1">
        {{ $t('views.exsbpriceuserdata.list.noPrices') }}
      </div>
      <div v-else>
        <table class="table table-sm table-responsive-md table-striped table-hover">
          <thead>
          <tr>
            <th>{{ $t('views.exsbpaymentsmade.list.contractor') }}</th>
            <th>{{ $t('views.exsbwarehouses.show.itemsStatesTable.item') }}</th>
            <th>{{ $t('views.exsbpriceuserdata.list.basePriceBrutto') }}</th>
            <th>{{ $t('views.exsbitems.form.priceBrutto') }}</th>
            <th style="width: 5%"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item['@id']">
            <td>
              <router-link
                v-if="item.idUserData.firmname1"
                :to="{name: 'FirmShow', params: {id: item.idUserData['@id']}}">
                {{ item.idUserData.firmname1 }}
              </router-link>
              <span v-else>
                {{ item.idUserData.fullName }}
              </span>
            </td>
            <td>{{ item.idItem.name }}</td>
            <td>{{ item.idItem.priceBrutto }}</td>
            <td>{{ item.priceBrutto }}</td>
            <td>
              <div class="btn-group">
                <router-link tag="button" class="btn btn-link fa fa-edit fa-lg" :to="{ name: 'EXSBPriceUserDataUpdate', params: { id: item['@id'] }}"></router-link>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-if="view">
        <Pagination :view="view" @getPage="getPage($event)"></Pagination>
      </div>
    </template>
  </BaseTableWrapper>

  <div v-else>
    <div v-if="isLoading">
      <Loader></Loader>
    </div>
    <div v-else-if="!isLoading && items.length < 1">
      {{ $t('views.exsbpriceuserdata.list.noPrices') }}
    </div>
    <table v-else class="table table-sm table-responsive-md table-striped table-hover">
      <thead>
      <tr>
        <th>{{ $t('views.exsbpaymentsmade.list.contractor') }}</th>
        <th>{{ $t('views.exsbwarehouses.show.itemsStatesTable.item') }}</th>
        <th>{{ $t('views.exsbpriceuserdata.list.basePriceBrutto') }}</th>
        <th>{{ $t('views.exsbitems.form.priceBrutto') }}</th>
<!--        <th>{{ $t('views.exsbitems.list.promotion') }}</th>-->
      </tr>
      </thead>
      <tbody>
      <tr v-for="item in items" :key="item['@id']">
        <td>{{ item.idUserData.firmname1 || item.idUserData.fullName }}</td>
        <td>{{ item.idItem.name }}</td>
        <td>{{ item.idItem.priceBrutto }}</td>
        <td>{{ item.priceBrutto }}</td>
<!--        <td v-if="item.idPromotion">{{item.idPromotion}}</td>-->
      </tr>
      </tbody>
    </table>
    <CreateModal></CreateModal>
  </div>
</template>

<script>
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import Pagination from '@/components/Dashboard/Layout/Pagination'
import Loader from '@/components/Dashboard/Layout/Loader'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles'
import addParamsToQuery from '@/utils/addParamsToQuery'
import getId from '@/utils/getIdFromLink'
import CreateModal from '@/components/Dashboard/Views/BusinessBundle/exsbpriceuserdata/modals/CreateModal'

export default {
  name: 'List',

  components: {
    BaseTableWrapper,
    Pagination,
    Loader,
    CreateModal
  },

  data () {
    return {
      url: 'e_x_s_b_price_user_datas',
      searchParams: {
        idItem: getId(this.item),
        idUserData: getId(this.userData)
      }
    }
  },

  props: ['item', 'userData'],

  computed: mapGetters({
    error: 'exsbpriceuserdata/list/error',
    items: 'exsbpriceuserdata/list/items',
    isLoading: 'exsbpriceuserdata/list/isLoading',
    view: 'exsbpriceuserdata/list/view'
  }),

  mounted () {
    this.setIdItem(this.item)
    this.setIdUserData(this.userData)
  },

  beforeCreate () {
    checkPagePermission('warehouses', 'EXSBPriceUserDataList')
  },

  created () {
    this.getPage(addParamsToQuery(this.url, this.searchParams))
  },

  methods: {
    ...mapMutations({
      setIdItem: 'exsbpriceuserdata/createModal/setIdItem',
      setIdUserData: 'exsbpriceuserdata/createModal/setIdUserData'
    }),
    ...mapActions({
      getPage: 'exsbpriceuserdata/list/getItems'
    })
  }
}
</script>

<style scoped>

</style>
